import React, { useEffect, useState } from "react";

import { gql } from "@examspark/api";
import { SelectInput } from "@examspark/common-ui";
import { Objective } from "@examspark/types";

/**
 * Shows a human-readable list of sections that correspond to the
 * grade-level/courses selected in the activity builder form.
 */
const SectionSelectInput = (
  props: React.ComponentProps<typeof SelectInput.Simple> & {
    authorityId?: string;
    documentId: string;
    objectiveSections?: string[];
  },
) => {
  const [sections, setSections] = useState<Objective[]>();

  useEffect(() => {
    gql.operations.objective
      .listObjectiveSections(
        props.authorityId ?? "tea",
        props.documentId.replace("document#", "section#"),
      )
      .then((rsp) => {
        setSections(
          rsp?.items?.filter((item) => {
            if (!props.objectiveSections) return true;
            return props.objectiveSections.includes(item.sk);
          }) || [],
        );
      });
  }, [props.authorityId, props.documentId, props.objectiveSections]);

  return (
    <div>
      <SelectInput.Simple
        placeholder="Select Grade Level..."
        {...props}
        options={
          sections?.map((section) => ({
            value: section.sk,
            label: section.content ?? "",
          })) ?? []
        }
      />
    </div>
  );
};

export default SectionSelectInput;
